export default __webpack_public_path__ + "static/media/water-5.05eb115c.png";